import { useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';

import { UserPool } from 'UserPool';

import { routes } from 'data/routes';

const useSignupForm = () => {
  const { handleSubmit, register } = useForm();
  const navigate = useNavigate();
  const [error, errorSet] = useState('');

  const onSubmit = async (data: FieldValues) => {
    const attributes = [];

    const name = {
      Name: 'name',
      Value: data.name,
    };

    const familyName = {
      Name: 'family_name',
      Value: data.family_name,
    };

    const attributeFamilyName = new CognitoUserAttribute(familyName);
    const attributeName = new CognitoUserAttribute(name);
    attributes.push(attributeFamilyName, attributeName);

    UserPool?.signUp(data.email, data.password, attributes, [], (err, output) => {
      if (err) {
        errorSet(err.message);
      }

      if (output) {
        navigate(routes.login);
      }
    });
  };

  return {
    handleSubmit,
    register,
    error,
    onSubmit,
  };
};

export { useSignupForm };
